import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { RecaptchaAction, RecaptchaData } from '@app/core/recaptcha/recaptcha-commons';

@Injectable({
  providedIn: 'root',
})
export class ReCaptchaService {
  private readonly baseApiKey = environment.recaptchaBaseKey;
  private readonly checkboxApiKey = environment.recaptchaCheckboxKey;

  public init(): void {
    const scriptTag = document.createElement('script');
    scriptTag.innerHTML = '';
    scriptTag.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.baseApiKey}`;
    document.head.appendChild(scriptTag);
  }

  public generateToken(actionName: RecaptchaAction): Observable<RecaptchaData> {
    const apiKey = this.baseApiKey;
    return new Observable(subscriber => {
      grecaptcha.enterprise.ready(async () => {
        try {
          const token = await grecaptcha.enterprise.execute(apiKey, { action: actionName });
          subscriber.next({
            token,
            apiKey,
          });
          subscriber.complete();
        } catch (e) {
          subscriber.error(e);
        }
      });
    });
  }

  public createCheckbox(container: HTMLElement): Observable<RecaptchaData> {
    const apiKey = this.checkboxApiKey;
    return new Observable<RecaptchaData>(subscriber => {
      grecaptcha.enterprise.ready(() => {
        grecaptcha.enterprise.render(container, {
          sitekey: apiKey,
          callback: (token: string) => {
            subscriber.next({
              token,
              apiKey,
            });
            subscriber.complete();
          },
        });
      });
    });
  }
}
